export default "__VITE_ASSET__CFTKGz32__"